<adapt-select-person [person]="allocatedConnection?.person"
                     (personChange)="updateAllocationPerson($event)"
                     [filter]="hasTier1Edit"
                     [userTypes]="allowedUserTypes"
                     [required]="false"></adapt-select-person>
